/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_Radius_MaxInputs */

const cs_requirements_radius_max = /** @type {(inputs: Requirements_Radius_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okruh může být nejvýše 200 km.`)
};

const en_requirements_radius_max = /** @type {(inputs: Requirements_Radius_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Radius can be at most 200 km.`)
};

/**
* | output |
* | --- |
* | "Radius can be at most 200 km." |
*
* @param {Requirements_Radius_MaxInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_radius_max = /** @type {((inputs?: Requirements_Radius_MaxInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_Radius_MaxInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_radius_max(inputs)
	return cs_requirements_radius_max(inputs)
});